import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface DeleteConfirmModalProps {
  open: boolean;
  pendingKey: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmModal({
  open,
  pendingKey,
  onCancel,
  onConfirm,
}: DeleteConfirmModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-5 z-[250] animate-fade-in"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden animate-slide-up delete-modal"
        onClick={e => e.stopPropagation()}
      >
        {/* Centered icon + text */}
        <div className="px-6 pt-8 pb-2 flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-danger-50 flex items-center justify-center mb-4 delete-modal-icon-ring">
            <WarningAmberIcon sx={{ fontSize: 28 }} className="text-danger-500" />
          </div>

          <h3 className="text-xl font-bold text-gray-900 mb-1.5 delete-modal-title">
            Delete Record
          </h3>

          <p className="text-base text-gray-500 delete-modal-description">
            Are you sure you want to delete this record? This action cannot be undone.
          </p>
        </div>

        {/* Action buttons */}
        <div className="px-6 pt-4 pb-6 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-gray-700 text-md font-semibold cursor-pointer transition-colors hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 bg-danger-500 border-none rounded-lg text-white text-md font-bold cursor-pointer transition-colors hover:opacity-90"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
